import { Component, Input } from '@angular/core';
import { TailwindMerge } from '@shared/src/interfaces/TwMerge.interface';

@Component({
  selector: 'lib-default-profile-icon',
  standalone: true,
  imports: [],
  templateUrl: './default-profile-icon.component.html',
  styleUrl: './default-profile-icon.component.css',
})
export class DefaultProfileIconComponent extends TailwindMerge {
  @Input() classes = '';
}
